import type { ReactNode } from 'react'
import { cn } from 'cn'
import { AudioPreviewLoader } from 'shared/components/audio-loader'
import type { AudioUploadAttachment } from 'modules/community/types/post-attachment'
import { AttachmentUploadStatusEnum } from 'modules/community/types/post-attachment'

interface AudioAttachmentPreviewProps {
  className?: string
  attachment: AudioUploadAttachment
}

export default function AudioAttachmentPreview({
  attachment,
  className,
}: AudioAttachmentPreviewProps): ReactNode {
  return (
    <div
      className={cn(
        'flex size-full overflow-hidden rounded-lg',
        attachment.status === AttachmentUploadStatusEnum.Uploading && `bg-bg-page`,
        className,
      )}
    >
      {attachment.status !== AttachmentUploadStatusEnum.Uploading && (
        <div className="w-full">
          <AudioPreviewLoader
            className="absolute top-1/2 left-1/2 -translate-1/2 md:size-8 lg:size-16"
            iconClassName="fill-icon-accent"
          />
          <span className="flex h-[90%] flex-col items-center justify-end text-xs text-text-tertiary">
            {attachment.name}
          </span>
        </div>
      )}
    </div>
  )
}
